import { memo } from "react";
import { Box } from "@mui/material";
import {
  DataGrid,
  DataGridProps,
  gridClasses,
  GridNoRowsOverlay,
} from "@mui/x-data-grid";

export const OrganizationPoliciesTable = memo(
  function OrganizationPoliciesTable(props: DataGridProps) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
        }}
      >
        <DataGrid
          columnHeaderHeight={54}
          rowHeight={54}
          disableRowSelectionOnClick
          disableColumnMenu
          slots={{ noRowsOverlay: NoRowsOverlay }}
          slotProps={{
            loadingOverlay: {
              variant: "linear-progress",
              noRowsVariant: "skeleton",
            },
          }}
          sx={{
            borderRadius: 2,
            border: "none",
            backgroundColor: "background.paper",
            [`& .${gridClasses.columnSeparator}`]: {
              [`&:not(.${gridClasses["columnSeparator--resizable"]})`]: {
                display: "none",
              },
            },
            [`& .${gridClasses.columnHeader}`]: {
              ...tableHeaderStyles,
              backgroundColor: (theme) =>
                theme.palette.mode === "light" ? "#D9D9DA" : "background.dark",
              borderBottom: "none !important",
            },
            [`& .${gridClasses.sortIcon}`]: {
              fontSize: "10px",
              color: "text.primary",
            },
            [`& .${gridClasses.footerContainer}`]: {
              backgroundColor: (theme) =>
                theme.palette.mode === "light" ? "#D9D9DA" : "background.dark",
              borderTop: "none !important",
              backgroundImage: "none",
              opacity: 1,
            },
            // remove focus outline
            [`& .${gridClasses.columnHeader}:focus`]: {
              outline: "none",
            },
            [`& .${gridClasses.columnHeader}:focus-within`]: {
              outline: "none",
            },
            [`& .${gridClasses.cell}:focus`]: {
              outline: "none",
            },
            [`& .${gridClasses.cell}:focus-within`]: {
              outline: "none",
            },
            "& .MuiDataGrid-row--borderBottom": {
              borderBottom: "none",
            },
            "& .left-cell": {
              pl: 3,
            },
            "& .right-cell": {
              pr: 3,
            },
          }}
          {...props}
        />
      </Box>
    );
  },
);

const tableHeaderStyles = {
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 700,
  lineHeight: "normal",
  color: "text.primary",
};

function NoRowsOverlay() {
  return (
    <GridNoRowsOverlay
      sx={{
        backgroundColor: "background.paper",
      }}
    />
  );
}
